// headLabels.ts — display names and print order for the claim heads
// (utils/claimHeads.js on the backend; `CLAIM_HEADS` in features/admin/
// types.ts). Same order and wording as backend/utils/finalBillHtml.js's
// HEAD_ORDER/HEAD_LABELS, so a head reads the same in the claims desk as on
// the printed Main Bill.
const HEAD_LABELS: Record<string, string> = {
  room: 'Room, boarding & diet', icu: 'ICU', nursing: 'Nursing / service / RMO',
  professional: 'Professional fees', procedure_misc: 'Procedure charges', ot: 'OT & anaesthesia equipment',
  investigation_lab: 'Investigations: laboratory', investigation_imaging: 'Investigations: imaging',
  investigation_other: 'Investigations: other', pharmacy: 'Pharmacy', consumables: 'Medical consumables',
  implants: 'Implants', package: 'Package', ambulance: 'Ambulance', misc: 'Miscellaneous', non_payable: 'Non-payable items',
};
const HEAD_ORDER = Object.keys(HEAD_LABELS);

export function headLabel(head: string): string {
  return HEAD_LABELS[head] ?? head;
}

/** Sort comparator: Main Bill order, unknown heads last (alphabetically). */
export function byHeadOrder(a: string, b: string): number {
  const ra = HEAD_ORDER.indexOf(a), rb = HEAD_ORDER.indexOf(b);
  return (ra === -1 ? HEAD_ORDER.length : ra) - (rb === -1 ? HEAD_ORDER.length : rb) || a.localeCompare(b);
}

/** The claims wireframes' `table.t` look, applied to every Table inside a
 * claims screen by putting this on the screen's wrapper: title-case 11px
 * bold headers on a soft band, tight 5–6px cells, 12.5px body text. A class
 * string (not per-cell props) so the shared Table primitive stays unchanged
 * for every other module. Tailwind scans this literal. */
export const SHEET_TABLES =
  '[&_th]:h-auto [&_th]:bg-muted [&_th]:text-[11px] [&_th]:text-ink-muted [&_th]:px-1.5 [&_th]:py-[5px] [&_th]:align-top [&_th]:font-bold [&_th]:normal-case [&_th]:tracking-normal ' +
  '[&_td]:px-1.5 [&_td]:py-[5px] [&_td]:align-top [&_td]:text-[12.5px]';
